import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const languages = [
  { code: "en", flag: "GB", label: "English" },
  { code: "fr", flag: "FR", label: "Francais" },
  { code: "es", flag: "ES", label: "Espanol" },
  { code: "de", flag: "DE", label: "Deutsch" },
  { code: "pt", flag: "PT", label: "Portugues" },
  { code: "ar", flag: "SA", label: "Arabic" },
];

const flagMap = {
  GB: "\uD83C\uDDEC\uD83C\uDDE7",
  FR: "\uD83C\uDDEB\uD83C\uDDF7",
  ES: "\uD83C\uDDEA\uD83C\uDDF8",
  DE: "\uD83C\uDDE9\uD83C\uDDEA",
  PT: "\uD83C\uDDF5\uD83C\uDDF9",
  SA: "\uD83C\uDDF8\uD83C\uDDE6",
};

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (value) => {
    i18n.changeLanguage(value);
    document.documentElement.lang = value;
  };

  return (
    <Select value={i18n.language?.substring(0, 2) || "en"} onValueChange={handleChange}>
      <SelectTrigger
        className="w-auto min-w-[120px] h-9 border-[#e2e8f0] bg-white text-sm gap-2"
        data-testid="language-switcher"
      >
        <Globe className="w-4 h-4 text-[#6b7280]" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code} data-testid={`lang-${lang.code}`}>
            <span className="flex items-center gap-2">
              <span>{flagMap[lang.flag]}</span>
              <span>{lang.label}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
